import React from 'react';
import {
  IconButton,
  Icon,
  useDisclosure,
  ButtonGroup,
  RemoveAlertDialog,
} from '@wegroup/design-system';
import PackageEditModal from './PackageEditModal';
import { InsurancePolicyPackage } from '../../../../../../types/AdvisoryReport';
import { useTranslation } from 'react-i18next';

interface Props {
  reportId: string;
  data: InsurancePolicyPackage;
  controlled?: boolean;

  // Actions
  onEdit?: (policyPackage: InsurancePolicyPackage) => void;
  onRemove?: () => void;
}

const PackageActions: React.FC<Props> = ({
  data,
  reportId,
  controlled,
  onEdit,
  onRemove,
}) => {
  const { t } = useTranslation();
  const {
    isOpen: isEditOpen,
    onClose: onCloseEdit,
    onOpen: onOpenEdit,
  } = useDisclosure();
  const {
    isOpen: isRemoveOpen,
    onClose: onCloseRemove,
    onOpen: onOpenRemove,
  } = useDisclosure();

  return (
    <>
      <PackageEditModal
        reportId={reportId}
        initialData={data}
        onEdit={onEdit}
        isOpen={isEditOpen}
        onClose={onCloseEdit}
      />
      <RemoveAlertDialog
        isOpen={isRemoveOpen}
        onClose={onCloseRemove}
        title={t('ARE-YOU-SURE')}
        description={t(
          'ADVISORY-REPORTS_CURRENT-INSURANCE_MODAL_DETAIL_INSURANCE_REMOVE-ALERT',
          { name: data.name },
        )}
        onConfirm={() => onRemove?.()}
      />
      <ButtonGroup isAttached>
        <IconButton
          aria-label="edit"
          variant="white"
          onClick={onOpenEdit}
          size="sm"
          icon={<Icon name="GeneralActionsEditDocument" boxSize="5" />}
        />
        <IconButton
          borderLeft="none"
          onClick={onOpenRemove}
          variant="white"
          size="sm"
          icon={
            <Icon name="GeneralActionsThrash" boxSize={5} color="danger.main" />
          }
          aria-label="Remove"
        />
      </ButtonGroup>
    </>
  );
};

export default PackageActions;
